export const BILLING_BOT_STATUS = 'bilingBotStatus';
export const BILLING_DETAILS_QUERY_KEY = 'billingDetails';
export const BILLING_GROUPS_QUERY_KEY = 'billingGroups';
export const BILLING_PARAMETERS_QUERY_KEY = 'billingParameters';
export const INVOICES_QUERY_KEY = 'invoices';
